import { twMerge } from "tailwind-merge";

interface ISignupTitleProps {
  className?: string;
  children: React.ReactNode;
}

const SignupTitle = ({ className, children }: ISignupTitleProps) => {
  return (
    <h2
      className={twMerge(
        "text-xl font-bold leading-normal text-center text-black",
        className
      )}
    >
      <div className="flex items-center justify-center gap-2">{children}</div>
    </h2>
  );
};

export default SignupTitle;
